export default {
  dialogTitle: "Create Canvas",
  canvasOptions: "Canvas Options",
  canvasInfo: "Canvas Information",
  canvasType: {
    label: "Canvas Type",
    placeholder: "Please select canvas type",
    multiCurrency: "Multi-Currency Canvas",
    singleCurrency: "Single Currency Canvas",
    solana: "Solana Canvas",
    tooltip:
      "Multi-Currency Canvas: Supports multi-chain and multi-currency analysis on the same canvas for Ethereum, BSC, and Tron, with comprehensive auxiliary analysis features\nSolana Canvas: Canvas analysis for Solana blockchain data\nSingle Currency Canvas: Single-chain, single-currency, single-address canvas analysis",
  },
  address: {
    label: "Analysis Address",
    labelWithHash: "Analysis Address/Hash",
    placeholder:
      "Please enter address or hash",
  },
  currency: {
    label: "Currency Type",
    placeholder: "Please select currency",
  },
  canvasName: {
    label: "Canvas Name",
    placeholder: "Please enter canvas name (required)",
  },
  canvasDescription: {
    label: "Canvas Description",
    placeholder: "Please enter canvas description (within 200 characters)",
  },
  buttons: {
    reset: "Reset",
    create: "Create",
  },
  validation: {
    canvasTypeRequired: "Please select canvas type",
    canvasConfigRequired: "Please select canvas configuration",
    currencyRequired: "Please select currency",
    addressRequired: "Please enter address",
    canvasNameRequired: "Canvas name is required",
  },
};
